module.exports = __webpack_public_path__ + "img/bingo_ball-65.cdd11eb6.png";